import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less'],
})
export class SpinnerComponent {
  @Input() value: number;
  @Output() onEnterPressed = new EventEmitter();

  increase() {
    this.value++;
  }

  decrease() {
    if (this.value > 0) {
      this.value--;
    }
  }

  onEnter() {
    this.onEnterPressed.emit();
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/spinner/spinner.component.ts